import { Button, Col, Flex, Row, Typography } from 'antd';
import { useQuery } from '@tanstack/react-query';
import { getAvailableSittingSchedules } from '../lib/api-client.ts';
import { SittingCard } from '../components/sitting/SittingCard.tsx';
import { Link } from 'react-router-dom';

export const HomePage = () => {
  const { data } = useQuery({
    queryKey: ['sittings', 'available'],
    queryFn: getAvailableSittingSchedules,
  });

  return (
    <>
      <Flex justify="space-between" wrap={true} style={{ margin: 16 }}>
        <Typography.Title level={5}>あなたのシッティング</Typography.Title>
        <Link to={'/sittings'}>
          <Button type="link">すべて見る</Button>
        </Link>
      </Flex>
      <Row gutter={[16, 16]} style={{ margin: 16 }}>
        {data && data.length !== 0 ? (
          data.map((sittingSchedule) => (
            <Col key={sittingSchedule.id} span={24}>
              <SittingCard sittingSchedule={sittingSchedule} />
            </Col>
          ))
        ) : (
          <Typography.Text disabled strong>
            対応が必要なシッティング予定はありません。
          </Typography.Text>
        )}
      </Row>
    </>
  );
};
